module.exports = flarum.core.compat['components/PostUser'];